import { render, staticRenderFns } from "./OrgChartComponent.vue?vue&type=template&id=06ec40ce&slot-scope=%7B%20nodeData%20%7D&"
import script from "./OrgChartComponent.vue?vue&type=script&lang=js&"
export * from "./OrgChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports